import React, { useEffect } from "react";
import Images from "../../images";
import { connect } from "react-redux";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { Tile } from "carbon-components-react";
function LessonPodItem(props) {
  const { CourseName, LessonName, DueDate, LessonColor } = props;
  return (
    <Tile className="lesson-card">
      <span className="lesson-title">{LessonName}</span>
      <span className="lesson-due-date">{"Due on " + DueDate}</span>
      <div className="lesson-thumbnail-container">
        <div
          className="lesson-thumbnail-div"
          style={{ backgroundColor: LessonColor }}
        >
          <img
            src={Images.lesson_thumbnail}
            alt="logo"
            style={{
              width: "50%",
              objectFit: "contain",
            }}
          />
        </div>
        <Box sx={{ width: "100%", color: "white" }}>
          <LinearProgress
            sx={{
              backgroundColor: "white",
              borderBottomLeftRadius: "8px",
              borderBottomRightRadius: "8px",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#ff551f",
                borderRadius: "8px",
              },
            }}
            style={{ backgroundColor: "#ffe9e2" }}
            variant="determinate"
            value={60}
          />
        </Box>
      </div>
    </Tile>
  );
}
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LessonPodItem);
